export { default as OreActionPlan } from './OreActionPlan.vue';
export { default as SearchStudent } from './SearchStudent.vue';
export { default as AlternativeInformation } from './AlternativeInformation.vue';
